module.exports = __webpack_public_path__ + "static/media/supply_kit_3.98947e6a.png";